import { Icon } from "./Icon.tsx";

/** "Cancel simulation" icon — paired with PlayIcon.tsx/SpinnerIcon.tsx for the Run Simulation button's own idle/running states. */
export function StopIcon() {
  return (
    <Icon>
      <path d="M6 6h12v12H6z" fill="currentColor" stroke="none" />
    </Icon>
  );
}
